import React from 'react';

const RightColumn = ({ children }) => (
  <div className="pt-2 lg:z-40 lg:sticky lg:top-0 lg:self-start lg:col-span-3 lg:w-auto lg:pt-0">
    <div className="relative w-full mx-auto lg:mx-0">{children}</div>
  </div>
);
export default RightColumn;
